import { get } from './utils';

const retrieve_menu = async (
    callback: ((data: any) => void) | null = null
): Promise<any> => {
    const path = '/menu/retrieve';
    const result = await get(path);
    console.debug('retrieve_menu', result);
    if (callback !== null) {
        callback(result?.data);
    } else return result?.data;
};

export { retrieve_menu };
